import React, {useState} from "react";
import clsx from "clsx";
import {UserLogin_SurveyQuestionPage_Options, UserLoginValue} from "data/models/survey/login";
import {Label, TextInput} from "flowbite-react";
import {QUESTION_CONTAINER_CLASS, TEXT_INPUT_THEME, TITLE_CLASS} from "components/Survey/classes";
import {getAuth} from "firebase/auth";
import {useAuthState} from "react-firebase-hooks/auth";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";

export type UserLogin_SurveyQuestionPage_Props = {
  options: UserLogin_SurveyQuestionPage_Options,
  questionId: string,
  value: UserLoginValue | undefined,
  onChange: (id: string, value: UserLoginValue | null) => void,
}

export default function UserLoginSurveyQuestionPage(
    {
      questionId,
      value,
      onChange
    }: UserLogin_SurveyQuestionPage_Props
) {
  const auth = getAuth();
  const [user] = useAuthState(auth);
  const [name, setName] = useState(value?.name);
  const [email, setEmail] = useState(value?.email ?? user?.email ?? undefined);

  function handleChange(editedName: string | undefined, editedEmail: string | undefined) {
    if (!isNullOrUndefined(editedEmail)) {
      setEmail(editedEmail);
    }
    if (!isNullOrUndefined(editedName)) {
      setName(editedName);
    }
    if (!isNullOrUndefined(editedEmail) && !isNullOrUndefined(editedName)) {
      onChange(questionId, {
        name: editedName,
        email: editedEmail,
      });
    } else {
      onChange(questionId, null);
    }
  }

  return <div className={clsx(QUESTION_CONTAINER_CLASS, "w-full max-w-xl mx-auto")}>
    <fieldset name={questionId} className="flex flex-col mt-4 gap-4 justify-center" autoFocus={true}>
      <div className={"mb-2  text-center"}>
        <Label className={TITLE_CLASS} htmlFor={questionId} value={"Your name"}/>
      </div>
      <TextInput
          id={`${questionId}.name`}
          type={'text'}
          theme={TEXT_INPUT_THEME}
          sizing={"lg"}
          placeholder={'John Doe'}
          required={true}
          value={name ?? ""}
          onChange={({target: {value: editValue}}) => handleChange(editValue, email)}
      />
      <div className={"mb-2 mt-8 text-center"}>
        <Label className={TITLE_CLASS} htmlFor={questionId} value={"Your email"}/>
      </div>
      <TextInput
          id={`${questionId}.email`}
          type={'email'}
          theme={TEXT_INPUT_THEME}
          sizing={"lg"}
          placeholder={'name@example.com'}
          required={true}
          value={email ?? ""}
          onChange={({target: {value: editValue}}) => handleChange(name, editValue)}
      />
      <div className={"text-sm text-gray-500"}>We will never share or sell your email address with anyone.</div>
    </fieldset>
  </div>
}
